import { GeneralRedirect } from 'Shared/Routes';
import ForgotPasswordPage from 'Shared/users/ForgotPasswordPage';
import { lazy } from 'solid-js';


/* Routes shared with artist GUI */
export function sharedRoutes()
{
	return [
		{
			path: '/forgotPassword',
//XXX At the time of writing the lazy() version was giving a rando Solid error when run in server mode (not Vite)
//			component: lazy(() => import('Shared/users/ForgotPasswordPage')),
			component: ForgotPasswordPage
		},
		{
			path: '/resetPassword/:key',
			component: lazy(() => import('Shared/users/ResetPasswordPage')),
		},
		{
			path: '/setPasswordAtRegistration/:key',
			component: lazy(() => import('Shared/users/SetPasswordAtRegistrationPage')),
		},

		/* 
			HACK to support the stripping of 'www.' by the AWS load balancer...

			The load balancer currently prevents me from just stripping the 'www.', claiming there would
			be a redirection loop. I need to change the path to convince it that things are OK (note that
			adding a query is not good enough).

			NOTE not copying over the query or anchor here. Shouldn't matter as 'www.' is not an official
			     domain for anyone (at the moment anyway).
		*/
		{
			path: '/redirected/*',
			component: () => <GeneralRedirect url='/' />
		},
	];
}


